export enum ButtonColorScheme {
  PRIMARY = 'primary',
  GRAY = 'gray',
  DANGER = 'danger',
}

export enum ButtonVariant {
  BASE = '',
  GHOST = 'ghost',
  OUTLINE = 'outline',
}
